/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/loot': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M14.5 17.5c-2-1-7-7-7-7l3-3s6 5 7 7 1 4 1 4-2 0-4-1zM3.5 5.5l2-2L9 7 7 9zM7 3l1.5 1.5v-3zM4.5 8.5L3 7 1.5 8.5z"/>'
  }
})
